<template>
  <div class="c-button" :style="styles" :class="disabled ? '__disabled' : ''">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    width: String,
    disabled: Boolean,
  },
  computed: {
    styles() {
      return {
        width: this.width,
      };
    },
  },
};
</script>

<style></style>
